/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Modal, ModalContent, ModalHeader } from '@cashfree-intl/coherent';

import useClickOutside from '../../../utils/hooks';

import { COMPLETED } from '../constants';

import CustomIcon from '../../../components/CustomIcons';
import PaytmForm from './PaytmForm';
import PaytmTransactions from './PaytmTransactions';
function PaytmModal({
  data,
  getPaytmCheckSumHash,
  addPaytmTestConfig,
  addPaytmProdConfig,
  isEditMode,
  resetEditMode,
  openModal,
  closeModal,
  testLoader,
  resetTestLoader,
  showPaytmForm,
  resetShowPaytmForm,
  accountStatus,
}) {
  const modalRef = useRef(null);

  useClickOutside(modalRef, closeModal);

  const { paytmTestConfig, paytmProdConfig } = data;
  const { stage } = paytmTestConfig;

  const showProdHeading =
    (stage === COMPLETED && showPaytmForm) ||
    (stage === COMPLETED && !isEmpty(paytmProdConfig));

  return (
    <Modal
      open
      className="common-modal-wrapper paytm-modal-wrapper"
      ref={modalRef}
    >
      <ModalHeader>
        <div>
          <div className="heading">
            {showProdHeading
              ? 'Submit Production API Credentials'
              : 'Connect your Paytm with Cashfree'}
          </div>
        </div>
        <div
          className="close-modal"
          data-event-name="PaytmModal_Icon_Close"
          data-ignore-inner-text="true"
          onClick={closeModal}
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent>
        {showPaytmForm ? (
          <PaytmForm
            data={{ paytmTestConfig, paytmProdConfig }}
            addPaytmTestConfig={addPaytmTestConfig}
            addPaytmProdConfig={addPaytmProdConfig}
            isEditMode={isEditMode}
            resetEditMode={resetEditMode}
            closeModal={closeModal}
            resetShowPaytmForm={resetShowPaytmForm}
          />
        ) : (
          <PaytmTransactions
            data={{ paytmTestConfig, paytmProdConfig }}
            getPaytmCheckSumHash={getPaytmCheckSumHash}
            resetEditMode={resetEditMode}
            openModal={openModal}
            closeModal={closeModal}
            testLoader={testLoader}
            resetTestLoader={resetTestLoader}
            resetShowPaytmForm={resetShowPaytmForm}
            accountStatus={accountStatus}
          />
        )}
      </ModalContent>
    </Modal>
  );
}

PaytmModal.propTypes = {
  data: PropTypes.object.isRequired,
  getPaytmCheckSumHash: PropTypes.func.isRequired,
  addPaytmTestConfig: PropTypes.func.isRequired,
  addPaytmProdConfig: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  resetEditMode: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  testLoader: PropTypes.bool.isRequired,
  resetTestLoader: PropTypes.func.isRequired,
  showPaytmForm: PropTypes.bool.isRequired,
  resetShowPaytmForm: PropTypes.func.isRequired,
  accountStatus: PropTypes.string.isRequired,
};

export default memo(PaytmModal);
